import { CopyInput } from '../../widgets/input';
import { Dialog, useDialogManager } from '../../widgets/dialog';
import { FormControl } from '../../widgets/formControl';
import React, { FC } from 'react';
import { graphql, useLazyLoadQuery } from 'react-relay';
import { T } from 'src/shared/helpers';
import { marketplacePreviewUrlDialogQuery } from './__generated__/marketplacePreviewUrlDialogQuery.graphql';

const MarketplacePreviewUrlDialog: FC<{
    productID: string;
}> = ({ productID }) => {
    const { closeDialog } = useDialogManager();

    const { marketplaceProductPreviewUrl } = useLazyLoadQuery<marketplacePreviewUrlDialogQuery>(
        graphql`
            query marketplacePreviewUrlDialogQuery($productID: ID!) {
                marketplaceProductPreviewUrl(productID: $productID)
            }
        `,
        { productID }
    );

    return (
        <Dialog
            onClose={() => {
                closeDialog('marketplace-preview-url');
            }}
            title={T._('Generate a shareable demo product URL', 'Admin')}
        >
            {(marketplaceProductPreviewUrl && (
                <>
                    <p>
                        {T._(
                            "Here, you can generate a demo product link and share it with your customers or add it to your description list, allowing them to preview and try out where they'll personalize their products.",
                            'Admin'
                        )}{' '}
                        {
                            <a href='https://zakeke.zendesk.com/hc/en-us/articles/14563026735132-Shareable-demo-product-URL-for-Etsy' target='_blank'>
                                {T._('Learn more', 'Admin')}
                            </a>
                        }
                    </p>
                    <FormControl label={T._('URL for your marketplace', 'Admin')}>
                        <CopyInput value={marketplaceProductPreviewUrl} />
                    </FormControl>
                </>
            )) || <p>{T._('The product must be published in a marketplace to obtains a marketplace sharable URL', 'Admin')}</p>}
        </Dialog>
    );
};

export default MarketplacePreviewUrlDialog;
